import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { kycAuthSuccess, kycAuthFailure } from "../../Action/kyc/kycAuthAction";
import { ACCEPT_REJECT } from "../../Action/actionTypes";
import { notifyPromise } from "../../../Utils/Helper";

function* kycAuthRequest(action) {
  try {
   

    const isAccepting =
      action?.payload?.payload?.type === "accept"
        ? `KYC accepting for ${action?.payload?.payload?.email}`
        : `KYC rejecting for ${action?.payload?.payload?.email}`;
    const {whitelabelId,paramtype}=action?.payload?.payload
    const { data } = yield notifyPromise(
      API.post(`/managekyc?whitelabelId=${whitelabelId}&registertype=${paramtype}`, action?.payload?.payload),
      isAccepting
    );

    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }
    if (data?.meta?.code === 200) {
      yield put(kycAuthSuccess(data?.data));
    } else {
      yield put(kycAuthFailure());
    }
  } catch (error) {
    yield put(kycAuthFailure());
  }
}

export function* watchKYCAuthAPI() {
  yield takeEvery(ACCEPT_REJECT, kycAuthRequest);
}

export default function* rootSaga() {
  yield all([watchKYCAuthAPI()]);
}
